'use client'
import { Button } from '@/components/Layout/aichat/Button'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Spinner } from '@material-tailwind/react'
import { Fragment, useEffect, useState } from 'react'
import styles from './index.module.css'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import { useRouter } from 'next/navigation'
import { supabaseGetAllByValue } from '@/lib/utils/providers/supabase/utils'
import { useSupabase } from '@/lib/utils/providers/supabase/supabase-provider'
import { notify } from '@/lib/utils/helpers'
import { createNewChatByAdmin } from '@/lib/utils/functions'

export default function SendNewMessage({ open, setOpen, company_user_id }) {
  const [message, setMessage] = useState('')
  const [isLoading, setLoading] = useState(false)
  const { createNewChatAndSendMessage, setRoomId, user } = useAuth()
  const { supabase } = useSupabase()
  const router = useRouter()

  const handleSendNewMessage = async () => {
    try {
      if (!message || message?.trim()?.length === 0) {
        notify('error', 'Message was empty.')
        return null
      }
      setLoading(true)
      const userData = await supabaseGetAllByValue(
        supabase,
        'users',
        'id',
        company_user_id,
        'name,email',
      )
      const chatName = userData?.name || userData?.email.split('@')[0]
      // const roomId = await createNewChatAndSendMessage(
      //   chatName,
      //   user.id,
      //   company_user_id,
      //   message,
      // )
      const roomId = await createNewChatByAdmin({
        chatName: chatName,
        user_id: user.id,
        company_user_id: company_user_id,
        message: message,
      })
      // console.log(roomId, '@@@@@@@@@@@@@@@@@@@@@@')
      setRoomId(roomId)

      router.push('/i/inbox')
      setOpen((open) => !open)
    } catch (error) {
      console.error('Error creating chat room:', error)
      //TODO: Handle error appropriately
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setMessage('')
  }, [open])

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className=" 
                                lg:w-[622px] lg:h-[]  p-6 bg-gradient-to-br from-zinc-950 to-neutral-950 
                                rounded-[10px] border border-zinc-900 flex-col "
              >
                <div className="flex flex-col ">
                  <div className="flex justify-between item">
                    <h1 className="text-gray-400 text-lg font-medium ">
                      Send Message
                    </h1>

                    <XMarkIcon
                      className="h-6 w-6 text-neutral-300 cursor-pointer"
                      onClick={() => setOpen(false)}
                    />
                  </div>
                  <div className="mt-3 text-center sm:mt-5">
                    <div className="flex w-full flex-col">
                      <p className="text-gray-400 text-sm font-normal text-left">
                        Message
                      </p>
                      <input
                        className="w-full h-[31px]  bg-zinc-900 rounded-lg border-zinc-900 bg-inherit placeholder:text-white text-white p-2
                                             focus:ring-inset focus:ring-none focus:outline-none focus:ring-0 border-0 "
                        placeholder="Message"
                        value={message}
                        disabled={isLoading}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>

                    <div className="flex mt-6 justify-end ">
                      <Button
                        onClick={handleSendNewMessage}
                        disabled={isLoading}
                        className={styles.nameButton}
                        fontSize="text-lg"
                      >
                        {isLoading && <Spinner className="w-5 h-5" />}
                        Send
                      </Button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
